import DMEFile from "../../../utils/services/project/accounting/dmeFileService";
import crudTemplate from "../../../templates/crudTemplate";

let crud = crudTemplate(DMEFile);
const state = {
  ...crud.state
};
const getters = {
  ...crud.getters
};

const actions = {
  ...crud.actions,
  create(_, { params, errorHandler = () => {}, onSuccess = () => {} }) {
    return DMEFile.create(params, onSuccess, () => {}, errorHandler);
  },
  download(_, { params }) {
    return DMEFile.download(params);
  },
  generate(_, { params, errorHandler = () => {}, onSuccess = () => {} }) {
    return DMEFile.generateDocuments(params, onSuccess, () => {}, errorHandler);
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
